/* =========================================================================
   JUSTFYX · Wallbox-Konfigurator
   Rechenlogik unveraendert aus dem Quell-Theme uebernommen:
   Installations-Pauschale + Montageort-Aufpreis + Meter ueber Freigrenze,
   Material-Grundbetrag + Wallbox-Aufpreis + Optionen, Anmeldung als eigene
   Position, Foerderung nur bei passender PLZ-Anfangsziffer (und ggf. PV).
   Alle Betraege in Cent (Ganzzahl), Formatierung erst bei der Ausgabe.
   ========================================================================= */
(function () {
  'use strict';

  var NS = (window.JFXCfg = window.JFXCfg || {});
  var EUR = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  function ganz(el, attr) {
    var v = parseInt(el.getAttribute(attr), 10);
    return isNaN(v) ? 0 : v;
  }

  function fmt(c) {
    return EUR.format(c / 100);
  }

  function liste(wurzel, selektor) {
    return Array.prototype.slice.call(wurzel.querySelectorAll(selektor));
  }

  function praefixTreffer(rohwert, ziffer) {
    if (!rohwert) return false;
    var teile = rohwert.split(',');
    for (var i = 0; i < teile.length; i++) {
      var t = teile[i].replace(/\s/g, '');
      if (t && ziffer && ziffer.indexOf(t) === 0) return true;
    }
    return false;
  }

  function init(root) {
    if (root.jfxWbBereit) return;
    root.jfxWbBereit = true;

    var boxen = liste(root, '[data-jfx-wb-box]');
    var plzFeld = root.querySelector('[data-jfx-wb-plz]');
    var regionAus = root.querySelector('[data-jfx-wb-region]');
    var regionen = liste(root, '[data-jfx-wb-regionen] > span');
    var montage = root.querySelector('[data-jfx-wb-montage]');
    var entfernung = root.querySelector('[data-jfx-wb-entfernung]');
    var optionen = liste(root, '[data-jfx-wb-opt]');
    var foerderungen = liste(root, '[data-jfx-wb-foerd]');
    var foerdZeile = root.querySelector('[data-jfx-wb-foerd-row]');
    var cartBtn = root.querySelector('[data-jfx-wb-cart]');
    var statusEl = root.querySelector('[data-jfx-wb-status]');
    var toastEl = root.querySelector('[data-jfx-wb-toast]');

    var aus = {};
    liste(root, '[data-jfx-wb-out]').forEach(function (el) {
      aus[el.getAttribute('data-jfx-wb-out')] = el;
    });

    var instBasis = ganz(root, 'data-inst-basis');
    var matBasis = ganz(root, 'data-material-basis');
    var meterPreis = ganz(root, 'data-meter-preis');
    var meterFrei = ganz(root, 'data-meter-frei');
    var regionFallback = root.getAttribute('data-region-fallback') || '';

    var stand = null;
    var toastTimer = null;

    function setzen(el, text) {
      if (el) el.textContent = text;
    }

    function toast(text, art) {
      if (!toastEl) return;
      toastEl.textContent = text;
      toastEl.setAttribute('data-art', art || 'info');
      toastEl.classList.add('ist-sichtbar');
      if (toastTimer) clearTimeout(toastTimer);
      toastTimer = setTimeout(function () {
        toastEl.classList.remove('ist-sichtbar');
      }, 5000);
    }

    function status(text, art) {
      if (!statusEl) return;
      statusEl.textContent = text || '';
      if (art) statusEl.setAttribute('data-status', art);
      else statusEl.removeAttribute('data-status');
    }

    function gewaehlteBox() {
      for (var i = 0; i < boxen.length; i++) {
        if (boxen[i].checked) return boxen[i];
      }
      return boxen[0] || null;
    }

    function optionenMit(schluessel) {
      return optionen.filter(function (o) {
        return o.getAttribute('data-schluessel') === schluessel;
      });
    }

    function gewaehlteOption(sel) {
      if (!sel || sel.selectedIndex < 0) return null;
      return sel.options[sel.selectedIndex] || null;
    }

    function berechnen() {
      var box = gewaehlteBox();

      /* --- Wallbox-Empfehlung --------------------------------------- */
      var wbPreis = box ? ganz(box, 'data-preis') : 0;
      var pvFaehig = box ? box.getAttribute('data-pv-faehig') === '1' : false;
      var anmeldungPflicht = box ? box.getAttribute('data-anmeldung-pflicht') === '1' : false;

      setzen(aus.kategorie, box ? box.getAttribute('data-kategorie') || '' : '');
      setzen(aus.name, box ? box.getAttribute('data-name') || '' : '');
      setzen(aus.text, box ? box.getAttribute('data-text') || '' : '');

      /* --- Installationsaufwand -------------------------------------- */
      var inst = instBasis;
      var montageOpt = gewaehlteOption(montage);
      if (montageOpt) inst += ganz(montageOpt, 'data-aufpreis');

      var entfernungOpt = gewaehlteOption(entfernung);
      var meter = entfernungOpt ? ganz(entfernungOpt, 'data-meter') : 0;
      if (meter > meterFrei) inst += (meter - meterFrei) * meterPreis;

      /* --- Material --------------------------------------------------- */
      var mat = matBasis;
      if (box) mat += ganz(box, 'data-material');

      /* --- Anmeldung Netzbetreiber (eigene Position) ------------------ */
      var anmeldungsOpt = optionenMit('anmeldung');
      if (anmeldungPflicht) {
        anmeldungsOpt.forEach(function (o) {
          if (!o.checked) o.checked = true;
        });
      }
      var an = 0;
      anmeldungsOpt.forEach(function (o) {
        if (o.checked) an += ganz(o, 'data-aufpreis');
      });

      /* --- Optionen mit Material-Wirkung ------------------------------ */
      optionenMit('material').forEach(function (o) {
        if (o.checked) mat += ganz(o, 'data-aufpreis');
      });

      /* --- PV-Ueberschussladen: nur bei geeigneter Wallbox ------------ */
      var pvGewaehlt = false;
      optionenMit('pv').forEach(function (o) {
        if (!o.checked) return;
        pvGewaehlt = true;
        if (pvFaehig) mat += ganz(o, 'data-aufpreis');
      });

      /* --- PLZ-Auswertung: Region ------------------------------------ */
      var plzWert = plzFeld ? (plzFeld.value || '').replace(/\D/g, '') : '';
      var ziffer = plzWert.substring(0, 1);
      var regionText = regionFallback;
      for (var r = 0; r < regionen.length; r++) {
        if (praefixTreffer(regionen[r].getAttribute('data-praefix'), ziffer)) {
          regionText = regionen[r].getAttribute('data-text') || regionFallback;
          break;
        }
      }
      setzen(regionAus, regionText);

      /* --- PLZ-Auswertung: Foerderung (unverbindlich) ---------------- */
      var foerd = 0;
      var foerdTitel = '';
      var genommen = false;
      foerderungen.forEach(function (li) {
        var badge = li.querySelector('[data-jfx-wb-foerd-status]');
        var passt = false;
        if (!genommen && li.getAttribute('data-anrechenbar') === '1') {
          var praefixe = li.getAttribute('data-praefixe') || '';
          var plzOk = praefixe.replace(/\s/g, '') === '' || praefixTreffer(praefixe, ziffer);
          var pvOk = li.getAttribute('data-nur-mit-pv') !== '1' || pvGewaehlt;
          if (plzOk && pvOk) {
            passt = true;
            genommen = true;
            foerd = ganz(li, 'data-betrag');
            foerdTitel = li.getAttribute('data-titel') || '';
          }
        }
        if (badge) {
          badge.textContent = passt ? 'in der Schätzung berücksichtigt' : '';
          badge.classList.toggle('jfx-cfg-hidden', !passt);
        }
      });

      if (foerdZeile) {
        foerdZeile.classList.toggle('jfx-cfg-hidden', foerd <= 0);
      }
      if (foerd > 0) {
        setzen(aus.foerderung, '− ' + fmt(foerd));
        if (aus.foerderungLabel && foerdTitel) {
          setzen(aus.foerderungLabel, foerdTitel + ' (ohne Gewähr)');
        }
      }

      /* --- Ausgabe ---------------------------------------------------- */
      var summe = wbPreis + inst + mat + an - foerd;

      setzen(aus.wallbox, fmt(wbPreis));
      setzen(aus.installation, fmt(inst));
      setzen(aus.material, fmt(mat));
      setzen(aus.anmeldung, fmt(an));
      setzen(aus.summe, fmt(summe));

      stand = {
        wallbox: box ? box.getAttribute('data-name') || '' : '',
        kategorie: box ? box.getAttribute('data-kategorie') || '' : '',
        plz: plzWert,
        region: regionText,
        montage: montageOpt ? montageOpt.textContent.trim() : '',
        entfernung: entfernungOpt ? entfernungOpt.textContent.trim() : '',
        optionen: optionen.filter(function (o) { return o.checked; }).map(function (o) {
          var titel = o.parentNode.querySelector('.jfx-cfg-choice__title');
          return titel ? titel.textContent.trim() : '';
        }).filter(Boolean),
        preise: {
          wallbox: wbPreis,
          installation: inst,
          material: mat,
          anmeldung: an,
          foerderung: foerd,
          foerderungTitel: foerdTitel,
          summe: summe
        }
      };
    }

    /* ------------------------------------------------------- Ereignisse - */

    boxen.forEach(function (el) { el.addEventListener('change', berechnen); });
    optionen.forEach(function (el) { el.addEventListener('change', berechnen); });
    if (montage) montage.addEventListener('change', berechnen);
    if (entfernung) entfernung.addEventListener('change', berechnen);
    if (plzFeld) {
      plzFeld.addEventListener('input', berechnen);
      plzFeld.addEventListener('change', berechnen);
    }

    berechnen();

    /* ---------------------------------------------------- Warenkorb ----- */

    if (cartBtn) {
      var variantRoh = (cartBtn.getAttribute('data-variant-id') || '').replace(/\D/g, '');
      if (!variantRoh) {
        cartBtn.disabled = true;
        cartBtn.setAttribute('aria-disabled', 'true');
        status('Der Warenkorb-Weg ist für diese Konfiguration nicht hinterlegt. Bitte nutzen Sie die Beratung oder rufen Sie an.', 'fehler');
      } else {
        cartBtn.addEventListener('click', function () {
          if (cartBtn.disabled) return;
          cartBtn.disabled = true;
          status('Anfrage wird übermittelt …');

          var props = {
            'Wallbox (Empfehlung)': stand.kategorie + (stand.wallbox ? ' · ' + stand.wallbox : ''),
            'PLZ': stand.plz,
            'Region': stand.region,
            'Montageort': stand.montage,
            'Leitungsweg': stand.entfernung,
            'Optionen': stand.optionen.length ? stand.optionen.join(', ') : 'keine',
            'Geschätzte Summe': fmt(stand.preise.summe),
            'Hinweis': 'Unverbindliche Schätzung, kein Angebot. Förderbeträge ohne Gewähr.'
          };
          if (stand.preise.foerderung > 0) {
            props['Angesetzte Förderung (ohne Gewähr)'] =
              stand.preise.foerderungTitel + ': ' + fmt(stand.preise.foerderung);
          }

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: parseInt(variantRoh, 10), quantity: 1, properties: props }]
            })
          }).then(function (res) {
            return res.json().then(function (daten) {
              if (!res.ok) throw new Error((daten && (daten.description || daten.message)) || ('HTTP ' + res.status));
              return daten;
            });
          }).then(function () {
            status('Konfiguration liegt im Warenkorb. Wir melden uns mit einem verbindlichen Angebot.', 'ok');
            toast('Konfiguration wurde in den Warenkorb gelegt.');
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }).catch(function (err) {
            status('Das hat nicht geklappt: ' + err.message + ' Bitte erneut versuchen oder anrufen.', 'fehler');
            toast('Fehler beim Hinzufügen: ' + err.message);
          }).then(function () {
            cartBtn.disabled = false;
          });
        });
      }
    }
  }

  function start(bereich) {
    liste(bereich || document, '[data-jfx-cfg="wallbox"]').forEach(init);
  }

  NS.wallbox = { start: start };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelectorAll) start(e.target);
  });
})();
